<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Product Types</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-btn color="accent" small to="/new-product-type">
            <v-icon left dark>mdi-plus</v-icon>New Product Type
          </v-btn>

          <v-spacer></v-spacer>
        </v-row>

        <v-row>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12" sm="5" md="5">
            <!-- start of table -->
            <v-data-table
              :headers="headers"
              :items="categories"
              :search="search"
            >
             <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn color="editIcon" text :to="`/product-type/${item.id}`" icon
                  ><v-icon>mdi-pencil</v-icon>
                </v-btn>

                <v-btn @click="openDisableDialog(item)" color="accent" text small>
                  <v-icon left small>mdi-cancel</v-icon>Disable
                </v-btn>

              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Disable Confirmation Dialog -->
    <v-dialog v-model="disableDialog" persistent max-width="600">
      <v-card>
        <v-card-title class="headline">Confirm Disable Category</v-card-title>
        <v-card-text>
          <p><strong>Are you sure you want to disable this category? This action will hide it from active categories.</strong></p>
          <v-divider class="my-3"></v-divider>
          <div v-if="selectedCategory" class="text-body-1">
            <p class="mb-2"><strong>Category Name:</strong> <span class="font-weight-medium">{{ selectedCategory.Name }}</span></p>
            <p class="mb-1 text-caption text--secondary">Note: Disabled categories can be re-enabled later if needed.</p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="disableDialog = false">Cancel</v-btn>
          <v-btn color="warning" @click="disableCategory" :loading="disableLoading">Disable</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    headers: [
      { text: "Name", value: "Name" },
      { text: "Action", value: "action" }
      ],
    categories: [],
    disableDialog: false,
    selectedCategory: null,
    disableLoading: false
  }),
  methods: {
    getCategories() {
      const self = this;
      this.$store
        .dispatch("get", `/product-types`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.categories = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    openDisableDialog(category) {
      this.selectedCategory = category;
      this.disableDialog = true;
    },
    disableCategory() {
      if (!this.selectedCategory) return;
      
      this.disableLoading = true;
      const data = {
        status: 1 // Change status from 0 to 1 to disable
      };
      
      const url = `/product-types/${this.selectedCategory.id}`;
      this.$store
        .dispatch("put", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            this.$refs.snackbar.show(" product type disabled successfully", "green");
            this.getCategories(); // Refresh the list to show only active categories
            this.disableDialog = false;
            this.selectedCategory = null;
          } else {
            this.$refs.snackbar.show(res.ResultDesc || res.msg, "red");
          }
          this.disableLoading = false;
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
          this.disableLoading = false;
        });
    },
  },
  created () {
    this.getCategories();
  },
};
</script>